<input
        [(ngModel)]="param"
        (ngModelChange)="doInput()"
        (blur)="doBlur()"
        class="form-control text-end"
        type="text"
        (keyup)="doKeyUp($event)"
        placeholder="0,00"
        tabIndex="{{tabIndex}}"
        inputmode="tel"
        [disabled]="readonly"
        value="{{inputValue}}"
        #myInput
/>
